import { makeStyles, mergeClasses, shorthands } from "@fluentui/react-components";

import { themeTokens } from "Core/Theme";

const useStyles = makeStyles({
    root: {
        ...shorthands.borderRadius(themeTokens.borderRadiusLarge),
        ...shorthands.padding(themeTokens.spacingVerticalS, themeTokens.spacingHorizontalS),
        display: "flex",
        width: "88px",
        height: "92px",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center"
    },
    icon: {
        color: themeTokens.colorPaletteMarigoldForeground3,
        height: "36px",
        width: "36px",
        ...shorthands.padding(themeTokens.spacingVerticalM, themeTokens.spacingHorizontalM),
        ...shorthands.border("1px", "solid", themeTokens.colorSubtleBackgroundPressed),
        ...shorthands.borderRadius(themeTokens.borderRadiusLarge)
    },
    name: {
        display: "flex",
        justifyContent: "center",
        width: "68px",
        ...shorthands.padding(themeTokens.spacingVerticalNone, themeTokens.spacingHorizontalL)
    }
});

const useHoverStyles = makeStyles({
    root: {
        // boxShadow: "0px 0.3px 0.9px rgba(0, 0, 0, 0.07), 0px 1.6px 3.6px rgba(0, 0, 0, 0.11)"
    }
});

export const useOverflowMenuItemStyles = (state: { isMouseOver: boolean }) => {
    const { isMouseOver } = state;
    const styles = useStyles();
    const hoverStyles = useHoverStyles();

    styles.root = isMouseOver ? mergeClasses(styles.root, hoverStyles.root) : styles.root;

    return styles;
};
